import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import './ContactUs.css';

const EMAILJS_SERVICE_ID = 'service_1um02uj';
const EMAILJS_TEMPLATE_ID = 'template_fyni63v';
const EMAILJS_PUBLIC_KEY = 'FJwOJU5vfZDqP3jks';

function ContactUs() {
  const formRef = useRef();
  const [status, setStatus] = useState('idle');
  const [errors, setErrors] = useState({});

  const validate = (formData) => {
    const newErrors = {};

    const name = formData.get('from_name').trim();
    const email = formData.get('from_email').trim();
    const subject = formData.get('subject').trim();
    const message = formData.get('message').trim();

    if (!name) newErrors.from_name = 'Name is required';
    if (!email) {
      newErrors.from_email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.from_email = 'Please enter a valid email address';
    }
    if (!subject) newErrors.subject = 'Subject is required';
    if (!message) {
      newErrors.message = 'Message is required';
    } else if (message.length < 10) {
      newErrors.message = 'Message must be at least 10 characters';
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(formRef.current);
    const validationErrors = validate(formData);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setStatus('sending');

    emailjs
      .sendForm(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, formRef.current, EMAILJS_PUBLIC_KEY)
      .then(() => {
        setStatus('success');
        formRef.current.reset();
      })
      .catch((error) => {
        console.error('EmailJS error:', error);
        setStatus('error');
      });
  };

  return (
    <div className="contact-page">
      <header className="contact-header">
        <div className="header-content">
          <h1>Contact Us</h1>
          <p className="subtitle">We'd love to hear from you</p>
        </div>
      </header>

      <main className="contact-content">
        {status === 'success' ? (
          <div className="success-message">
            <span className="success-icon">✅</span>
            <h2>Message Sent!</h2>
            <p>
              Thank you for reaching out. We'll get back to you as soon as
              possible.
            </p>
            <button
              className="send-another-btn"
              onClick={() => setStatus('idle')}
            >
              Send Another Message
            </button>
          </div>
        ) : (
          <>
            <p className="contact-intro">
              Have a question, suggestion, or need help with Plant Care
              Reminder? Fill out the form below and we'll get back to you.
            </p>

            {status === 'error' && (
              <div className="error-banner">
                Something went wrong. Please try again or email us directly at{' '}
                <a href="mailto:muhammedsalihyildiz18@gmail.com">
                  muhammedsalihyildiz18@gmail.com
                </a>
              </div>
            )}

            <form ref={formRef} onSubmit={handleSubmit} noValidate>
              <div className="form-group">
                <label htmlFor="from_name">Name</label>
                <input
                  type="text"
                  id="from_name"
                  name="from_name"
                  placeholder="Your full name"
                  className={errors.from_name ? 'input-error' : ''}
                />
                {errors.from_name && (
                  <span className="field-error">{errors.from_name}</span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="from_email">Email</label>
                <input
                  type="email"
                  id="from_email"
                  name="from_email"
                  placeholder="your@email.com"
                  className={errors.from_email ? 'input-error' : ''}
                />
                {errors.from_email && (
                  <span className="field-error">{errors.from_email}</span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  placeholder="What is this about?"
                  className={errors.subject ? 'input-error' : ''}
                />
                {errors.subject && (
                  <span className="field-error">{errors.subject}</span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="6"
                  placeholder="Tell us how we can help..."
                  className={errors.message ? 'input-error' : ''}
                />
                {errors.message && (
                  <span className="field-error">{errors.message}</span>
                )}
              </div>

              <button
                type="submit"
                className="submit-btn"
                disabled={status === 'sending'}
              >
                {status === 'sending' ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </>
        )}
      </main>

      <footer className="contact-footer">
        <p>
          &copy; {new Date().getFullYear()} Plant Care Reminder. All rights
          reserved.
        </p>
      </footer>
    </div>
  );
}

export default ContactUs;
